<form novalidate autocomplete="off" #form="ngForm" (submit)="onSubmit(form)">
  <!-- <input type="hidden" name="cartId" [value]="service.Model?.CartID" /> -->
  <div class="row gx-5 mx-1 mh-60 bg-white border">
    <div class="form-group col-md-7 d-flex align-items-center px-2 mt-3">
      <input type="text" id="promoCode" placeholder="Enter Coupon" style="width:100%;" name="promoCode"
             #promoCode="ngModel" [(ngModel)]="service.promoFormData.promoCode"
             required [class.invalid]="promoCode.invalid && promoCode.touched">
    </div>
    <div class="form-group col-md-5 d-flex align-items-center mt-3">
      <button class="btn btn-primary btn-sm btn-block" type="submit" [disabled]="form.invalid">SUBMIT</button>
    </div>
    </div>
</form>
